import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {MultiCartService, StateWithMultiCart} from '@spartacus/cart/base/core';
import {UserIdService} from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class DcpMultiCartService extends MultiCartService {
  private lastMergedCartId: string;

  constructor(protected store: Store<StateWithMultiCart>, protected userIdService: UserIdService) {
    super(store, userIdService);
  }

  mergeToCurrentCart({
    userId,
    cartId,
    extraData,
  }: {
    userId: string;
    cartId: string;
    extraData?: {active?: boolean};
  }): void {
    // prevent merging the same cart twice and therefore creating duplicated carts
    if (this.lastMergedCartId !== cartId) {
      this.lastMergedCartId = cartId;
      super.mergeToCurrentCart({userId, cartId, extraData});
    }
  }
}
